import React, { useEffect, useState, useRef } from 'react';
import { animate, useInView, useReducedMotion } from 'framer-motion';
type AnimatedMetricProps = {
  value: number;
  suffix?: string;
  decimals?: number;
  className?: string;
  ariaLabel: string;
};
export function AnimatedMetric({
  value,
  suffix = '',
  decimals = 0,
  className = '',
  ariaLabel
}: AnimatedMetricProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const isInView = useInView(ref, {
    once: true,
    amount: 0.8
  });
  const reduceMotion = useReducedMotion();
  const [currentValue, setCurrentValue] = useState(reduceMotion ? value : 0);
  const currentValueRef = useRef(currentValue);
  useEffect(() => {
    if (!isInView || reduceMotion) {
      if (reduceMotion) {
        currentValueRef.current = value;
        setCurrentValue(value);
      }
      return;
    }
    const controls = animate(currentValueRef.current, value, {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: nextValue => {
        currentValueRef.current = nextValue;
        setCurrentValue(nextValue);
      }
    });
    return () => controls.stop();
  }, [isInView, reduceMotion, value]);
  const formattedValue = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals
  }).format(currentValue);
  return <span ref={ref} className={className} aria-label={ariaLabel} data-id="element-8">
      <span aria-hidden="true" data-id="element-9">
        {formattedValue}
        {suffix}
      </span>
    </span>;
}